import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import PieChart from "../../reuseableComponents/graphsAndCharts/DeqPieChart";
import ChartLegend from "../../reuseableComponents/graphsAndCharts/ChartLegend";
import { GET_COMMUNITY_POP_SERVED } from "../../../queries/archiveQrys/secureQrys/statewideReportQry";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const CommWaterSysPopChart = () => {
  const { loading, data, error } = useQuery(GET_COMMUNITY_POP_SERVED);

  if (loading || error) {
    return (
      <>
        <Row>
          <Col>
            <h3>Community Water System by Population</h3>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </>
    );
  }
  const colors = ["#0080b7", "#00afd8", "#636363", "#add361", "#5fa7be"];
  return (
    <>
      <Row>
        <Col>
          <h3>Community Water System by Population</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='CommWtrSysPopLegend'>
          <ChartLegend data={data.getCommutnityWaterSystsemCountsByPopulationServed} colorArray={colors} />
        </Col>
      </Row>
      <Row>
        <Col cypressid='CommWtrSysPopChart'>
          <PieChart data={data.getCommutnityWaterSystsemCountsByPopulationServed} colorArray={colors} />
        </Col>
      </Row>
    </>
  );
};
export default CommWaterSysPopChart;
